module.exports = __webpack_public_path__ + "cu.svg?28ccb9c845c1c52bf2297045c02047e9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cu.svg
// module id = 1033
// module chunks = 27